import { HeartbeatAppletFilters } from '@tapestry/types';

export const DEFAULT_FILTERS: HeartbeatAppletFilters = {
  isVoid: 'false',
};
